import React from "react";
import clsx from "clsx";
import Scrollbars from "react-custom-scrollbars";
import { ClickAwayListener, MenuItem } from "@material-ui/core";
import { isEmpty } from "helpers/utils/isEmpty";
import "./styles.scss";

const TagTaskModal = ({
  isOpen,
  handleClose,
  handleClickMention,
  selectedId,
  tagTasks,
}) => {
  function handleSelectTag(index) {
    return () => {
      handleClose();
      handleClickMention(tagTasks[index]);
    };
  }

  return isOpen ? (
    <ClickAwayListener onClickAway={handleClose}>
      <div className={clsx("TagTaskModal", { TagTaskModal__open: isOpen })}>
        <Scrollbars autoHeight autoHeightMin={42} autoHeightMax={350}>
          {!isEmpty(tagTasks) &&
            tagTasks.map((el, index) => (
              <MenuItem
                key={el.id}
                className={clsx("TagTaskModal--menuItem", {
                  "TagTaskModal--menuItem__selected": selectedId === index,
                })}
                onClick={handleSelectTag(index)}
              >
                # {el.name}
              </MenuItem>
            ))}
        </Scrollbars>
      </div>
    </ClickAwayListener>
  ) : null;
};

export default React.memo(TagTaskModal);
